module.exports = __webpack_public_path__ + "img/video-class.06e36b96.svg";